// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateDetailHeader":"TaskTemplateDetailHeader__taskTemplateDetailHeader__32jWO","backToOverview":"TaskTemplateDetailHeader__backToOverview__37RAu","icon":"TaskTemplateDetailHeader__icon__3lv34"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateDetailView/TaskTemplateDetailHeader/TaskTemplateDetailHeader.scss
// module id = 1879
// module chunks = 0